import { render, staticRenderFns } from "./AdminPerformanceReports.vue?vue&type=template&id=5e529b05"
import script from "./AdminPerformanceReports.vue?vue&type=script&lang=js"
export * from "./AdminPerformanceReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports